<div <% if (booking.provider.image_url) { %>style="background-image: url(<%= booking.provider.image_url %>);"<% } %> class="item-icon --doctor"></div>
<div class="item-content">
  <div class="doctor-name" translate="no">
    <strong><%- booking.provider.name %></strong>
  </div>
  <div class="doctor-specialty">
    <% if (booking.provider.provider_credentials_for_label) { %>
      <%- booking.provider.provider_credentials_for_label.join(', ') %>
    <% } %>
  </div>
</div>
